 

import React from "react";
import PdfEditor from "./pdfEditor";

function Editor(props) {
 
  switch (props.type) {
    // case "txt":
    case "pdf": {
      
      return <PdfEditor {...props} />;
    }
    case "txt": {
      return <PdfEditor {...props} strict />;
    }
    default:
      return null;
  }
}

export default Editor;
